import * as React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import ContentWrapper from "./ContentWrapper";

const StyledFooter = styled.footer`
  width: 100%;
  padding: 16px 0;
  background: #20232a;
`;

const FooterNav = styled.nav`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const Logo = styled.div`
  padding: 1.2rem;
`;

const Copyright = styled.p`
  color: #999999;
  text-align: center;
`;

const Menu = styled.div``;

const LinkList = styled.div`
  display: flex;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const LinkItem = styled.ul`
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 0.5rem 2rem;
  }
`;

const StyledLink = styled(Link)`
  font-size: 1.1rem;
  color: white;
  &:hover {
    color: #61dafb;
  }
`;

const Footer = () => {
  return (
    <StyledFooter>
      <ContentWrapper>
        <FooterNav>
          <Logo>
            <Link to="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="250"
                height="50"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  d="M28.125 12.5c0-4.627 2.514-8.666 6.25-10.828C32.536.609 30.402 0 28.125 0c-6.904 0-12.5 5.596-12.5 12.5 0 1.271.19 2.499.543 3.655-1.557 1.555-2.706 3.517-3.272 5.714l-.395.006c-4.627 0-8.666-2.514-10.828-6.25C.609 17.464 0 19.598 0 21.875c0 6.904 5.596 12.5 12.5 12.5 1.271 0 2.499-.19 3.655-.543 1.555 1.557 3.517 2.706 5.714 3.272l.006.395c0 4.627-2.514 8.666-6.25 10.828A12.44 12.44 0 0 0 21.875 50c6.904 0 12.5-5.596 12.5-12.5 0-1.272-.19-2.499-.543-3.655 1.557-1.554 2.706-3.517 3.272-5.714.131-.004.263-.006.395-.006 4.627 0 8.666 2.514 10.828 6.25A12.44 12.44 0 0 0 50 28.125c0-6.904-5.596-12.5-12.5-12.5-1.272 0-2.499.19-3.655.543-1.554-1.557-3.517-2.706-5.714-3.272l-.006-.395z"
                  fill="#f4bc46"
                />
                <path
                  d="M73.623 25.592c-2.895-.832-5.004-1.852-6.328-3.059-1.312-1.219-1.969-2.719-1.969-4.5 0-2.016.803-3.68 2.408-4.992 1.617-1.324 3.715-1.986 6.293-1.986 1.758 0 3.322.34 4.693 1.019 1.383.68 2.449 1.617 3.199 2.813a7.15 7.15 0 0 1 1.143 3.92H79.67c0-1.547-.492-2.76-1.477-3.639-.984-.891-2.373-1.336-4.166-1.336-1.664 0-2.965.369-3.902 1.108-.926.726-1.389 1.74-1.389 3.041 0 1.043.439 1.928 1.318 2.654.891.715 2.397 1.371 4.518 1.969 2.133.598 3.797 1.26 4.992 1.986 1.207.715 2.098 1.553 2.672 2.514.586.961.879 2.092.879 3.393 0 2.074-.809 3.738-2.426 4.992-1.617 1.242-3.779 1.863-6.486 1.863-1.758 0-3.398-.334-4.922-1.002-1.523-.68-2.701-1.605-3.533-2.777-.82-1.172-1.23-2.502-1.23-3.99h3.393c0 1.547.568 2.771 1.705 3.674 1.148.891 2.678 1.336 4.588 1.336 1.781 0 3.146-.363 4.096-1.09s1.424-1.717 1.424-2.971-.44-2.221-1.318-2.9c-.879-.691-2.473-1.371-4.781-2.039zm16.576-5.309c1.441-1.77 3.316-2.654 5.625-2.654 4.02 0 6.047 2.268 6.082 6.803V37h-3.252V24.414c-.012-1.371-.328-2.385-.949-3.041-.609-.656-1.564-.984-2.865-.984-1.055 0-1.98.281-2.777.844s-1.418 1.301-1.863 2.215V37h-3.252V10h3.252v10.283zm15.715 7.031c0-1.863.363-3.539 1.09-5.027.738-1.488 1.758-2.637 3.058-3.445 1.313-.809 2.807-1.213 4.483-1.213 2.59 0 4.682.896 6.275 2.689 1.606 1.793 2.409 4.178 2.409 7.154v.229c0 1.852-.358 3.516-1.073 4.992-.703 1.465-1.717 2.607-3.041 3.428-1.312.82-2.824 1.23-4.535 1.23-2.578 0-4.67-.896-6.275-2.689-1.594-1.793-2.391-4.166-2.391-7.119v-.229zm3.27.387c0 2.109.486 3.803 1.459 5.08.984 1.277 2.296 1.916 3.937 1.916 1.652 0 2.965-.645 3.938-1.934.972-1.301 1.459-3.117 1.459-5.449 0-2.086-.498-3.773-1.495-5.062-.984-1.301-2.296-1.951-3.937-1.951-1.606 0-2.9.639-3.885 1.916s-1.476 3.105-1.476 5.484zm17.349-.369c0-2.965.686-5.32 2.057-7.066 1.371-1.758 3.187-2.637 5.449-2.637 2.32 0 4.131.82 5.432 2.461l.158-2.109h2.971v18.563c0 2.461-.733 4.4-2.198 5.818-1.453 1.418-3.41 2.127-5.871 2.127-1.371 0-2.713-.293-4.025-.879s-2.315-1.389-3.006-2.408l1.688-1.951c1.394 1.723 3.099 2.584 5.115 2.584 1.582 0 2.812-.445 3.691-1.336.891-.891 1.336-2.145 1.336-3.762v-1.635c-1.301 1.5-3.076 2.25-5.326 2.25-2.227 0-4.031-.896-5.414-2.689-1.371-1.793-2.057-4.236-2.057-7.33zm3.27.369c0 2.145.439 3.832 1.318 5.063.879 1.219 2.109 1.828 3.691 1.828 2.051 0 3.557-.932 4.518-2.795v-8.684c-.996-1.816-2.49-2.725-4.482-2.725-1.582 0-2.819.615-3.709 1.846s-1.336 3.053-1.336 5.467zM151.055 37h-3.252V17.981h3.252V37zm-3.516-24.065c0-.527.158-.973.475-1.336.328-.363.808-.545 1.441-.545s1.113.182 1.441.545.493.809.493 1.336-.164.967-.493 1.318-.808.527-1.441.527-1.113-.176-1.441-.527c-.317-.352-.475-.791-.475-1.318zm16.787 12.656c-2.894-.832-5.004-1.852-6.328-3.059-1.312-1.219-1.969-2.719-1.969-4.5 0-2.016.803-3.68 2.409-4.992 1.617-1.324 3.714-1.986 6.292-1.986 1.758 0 3.323.34 4.694 1.019 1.383.68 2.449 1.617 3.199 2.813a7.15 7.15 0 0 1 1.143 3.92h-3.393c0-1.547-.492-2.76-1.477-3.639-.984-.891-2.373-1.336-4.166-1.336-1.664 0-2.964.369-3.902 1.108-.926.726-1.389 1.74-1.389 3.041 0 1.043.44 1.928 1.319 2.654.89.715 2.396 1.371 4.517 1.969 2.133.598 3.797 1.26 4.993 1.986 1.207.715 2.097 1.553 2.671 2.514.586.961.879 2.092.879 3.393 0 2.074-.808 3.738-2.425 4.992-1.618 1.242-3.78 1.863-6.487 1.863-1.758 0-3.398-.334-4.922-1.002-1.523-.68-2.701-1.605-3.533-2.777-.82-1.172-1.23-2.502-1.23-3.99h3.392c0 1.547.569 2.771 1.705 3.674 1.149.891 2.678 1.336 4.588 1.336 1.782 0 3.147-.363 4.096-1.09s1.424-1.717 1.424-2.971-.44-2.221-1.319-2.9c-.878-.691-2.472-1.371-4.781-2.039zm17.736-12.217v4.605h3.551v2.514h-3.551v11.795c0 .762.159 1.336.475 1.723.317.375.856.563 1.617.563.375 0 .891-.07 1.547-.211V37c-.855.234-1.687.352-2.496.352-1.453 0-2.549-.439-3.287-1.318s-1.107-2.127-1.107-3.744V20.494h-3.463v-2.514h3.463v-4.605h3.251zM201.17 37c-.188-.375-.34-1.043-.457-2.004-1.512 1.57-3.317 2.355-5.414 2.355-1.875 0-3.416-.527-4.623-1.582-1.196-1.066-1.793-2.414-1.793-4.043 0-1.981.75-3.516 2.25-4.606 1.512-1.102 3.633-1.652 6.363-1.652h3.164v-1.494c0-1.137-.34-2.039-1.019-2.707-.68-.68-1.682-1.02-3.006-1.02-1.16 0-2.133.293-2.918.879s-1.178 1.295-1.178 2.127h-3.269c0-.949.334-1.863 1.001-2.742.68-.891 1.594-1.594 2.743-2.109 1.16-.516 2.431-.773 3.814-.773 2.192 0 3.908.551 5.151 1.652 1.242 1.09 1.886 2.596 1.933 4.518v8.754c0 1.746.223 3.135.668 4.166V37h-3.41zm-5.397-2.478c1.02 0 1.987-.264 2.901-.791s1.576-1.213 1.986-2.057v-3.902h-2.549c-3.984 0-5.976 1.166-5.976 3.498 0 1.02.34 1.816 1.019 2.391s1.553.861 2.619.861zm17.649-21.147v4.605h3.551v2.514h-3.551v11.795c0 .762.158 1.336.474 1.723.317.375.856.563 1.618.563.375 0 .89-.07 1.547-.211V37c-.856.234-1.688.352-2.497.352-1.453 0-2.548-.439-3.287-1.318s-1.107-2.127-1.107-3.744V20.494h-3.463v-2.514h3.463v-4.605h3.252zm18.439 18.58c0-.879-.334-1.559-1.002-2.039-.656-.492-1.81-.914-3.463-1.266-1.64-.352-2.947-.773-3.919-1.266-.961-.492-1.676-1.078-2.145-1.758-.457-.68-.686-1.488-.686-2.426 0-1.559.657-2.877 1.969-3.955 1.324-1.078 3.012-1.617 5.063-1.617 2.156 0 3.902.557 5.238 1.67a5.29 5.29 0 0 1 2.022 4.272h-3.27c0-.891-.381-1.658-1.143-2.303-.75-.645-1.699-.967-2.847-.967-1.184 0-2.11.258-2.778.773a2.43 2.43 0 0 0-1.002 2.021c0 .785.311 1.377.932 1.775s1.74.779 3.358 1.143c1.628.363 2.947.797 3.955 1.301s1.752 1.113 2.232 1.828c.492.703.738 1.564.738 2.584 0 1.699-.679 3.064-2.039 4.096-1.359 1.02-3.123 1.529-5.291 1.529-1.523 0-2.871-.27-4.043-.809s-2.092-1.289-2.76-2.25c-.656-.973-.984-2.021-.984-3.146h3.252c.059 1.09.492 1.957 1.301 2.601.82.633 1.898.949 3.234.949 1.231 0 2.215-.246 2.953-.738.75-.504 1.125-1.172 1.125-2.004z"
                  fill="#fff"
                />
              </svg>
            </Link>
            <Copyright>
              <small>Copyright &copy; 2021 iruda</small>
            </Copyright>
          </Logo>
          <Menu>
            <LinkList>
              <LinkItem>
                <StyledLink to="/about/">About</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/fixtures/">Fixtures</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/results/">Results</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/players/">Players</StyledLink>
              </LinkItem>
              {/* <LinkItem>
                <StyledLink to="/ranking/">Ranking</StyledLink>
              </LinkItem> */}
              {/* <LinkItem>
                <StyledLink to="/more/">More</StyledLink>
              </LinkItem> */}
              <LinkItem>
                <StyledLink to="/books/">Books</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/sns/">SNS</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/blog/">Blog</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/birthplace/">Birthplace</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/venue/">Venue</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/stats/">Stats</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/ranking/">Ranking</StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="https://docs.google.com/forms/d/e/1FAIpQLSdvneH9a1EODaanY249rsDYxL-edbwT7-iD-hN1tUagYocXVw/viewform?usp=sf_link">
                  Contact
                </StyledLink>
              </LinkItem>
              <LinkItem>
                <StyledLink to="/privacy/">Privacy</StyledLink>
              </LinkItem>
            </LinkList>
          </Menu>
        </FooterNav>
      </ContentWrapper>
    </StyledFooter>
  );
};

export default Footer;
